function Technologies() {
    return (
        <>
            <div id="technologies" className="technologies bg-neutral-50">
            <div className="container max-w-screen-sm mx-auto py-8 px-4 flex flex-col justify-center items-center">
                <h2 className="font-bold text-red-500 uppercase">technologies</h2>
                <h1 className="font-bold text-2xl text-center">Technologies I use at work</h1>
                <hr className="border-b-2 w-60 my-3 text-center" />

                <section className="w-full flex justify-center items-start max-sm:flex-col">
                    <aside className="w-1/3 max-sm:w-full max-sm:px-4">
                        <h2 className="text-center mb-2 underline">Tools</h2>
                        <div className="bg-gray-200 rounded-lg p-4 mb-4 flex items-center">
                            <img src="https://github.com/tandpfun/skill-icons/raw/main/icons/VSCode-Dark.svg" alt="icon"
                                className="w-fit h-12 mr-4" />
                            <p>VS Code</p>
                        </div>
                        <div className="bg-gray-200 rounded-lg p-4 mb-4 flex items-center">
                            <img src="https://github.com/tandpfun/skill-icons/raw/main/icons/Figma-Dark.svg" alt="icon"
                                className="w-fit h-12 mr-4" />
                            <p>Figma</p>
                        </div>
                        <div className="bg-gray-200 rounded-lg p-4 mb-4 flex items-center">
                            <img src="https://seeklogo.com/images/C/coreldraw-x7-logo-747B0DC253-seeklogo.com.png"
                                alt="icon" className="rounded-lg w-fit h-12 mr-4" />
                            <p>CorelDRAW</p>
                        </div>
                        <div className="bg-gray-200 rounded-lg p-4 mb-4 flex items-center">
                            <img src="https://github.com/tandpfun/skill-icons/raw/main/icons/Blender-Dark.svg"
                                alt="icon" className="w-fit h-12 mr-4" />
                            <p>Blender</p>
                        </div>
                        <div className="bg-gray-200 rounded-lg p-4 mb-4 flex items-center">
                            <img src="https://seeklogo.com/images/A/autodesk-fusion-360-logo-7F72A76397-seeklogo.com.png"
                                alt="icon" className="w-fit h-12 mr-4" />
                            <p>Fusion 360</p>
                        </div>
                        <div className="bg-gray-200 rounded-lg p-4 mb-4 flex items-center">
                            <img src="https://github.com/tandpfun/skill-icons/raw/main/icons/Photoshop.svg" alt="icon"
                                className="w-fit h-12 mr-4" />
                            <p>Photoshop</p>
                        </div>
                    </aside>
                    <aside className="w-1/3 mx-4 max-sm:w-full max-sm:px-4 max-sm:mx-0">
                        <h2 className="text-center mb-2 underline">Development</h2>
                        <div className="bg-gray-200 rounded-lg p-4 mb-4 flex items-center">
                            <img src="https://github.com/tandpfun/skill-icons/raw/main/icons/JavaScript.svg" alt="icon"
                                className="w-fit h-12 mr-4" />
                            <p>JavaScript</p>
                        </div>
                        <div className="bg-gray-200 rounded-lg p-4 mb-4 flex items-center">
                            <img src="https://github.com/tandpfun/skill-icons/raw/main/icons/Java-Dark.svg" alt="icon"
                                className="w-fit h-12 mr-4" />
                            <p>Java</p>
                        </div>
                        <div className="bg-gray-200 rounded-lg p-4 mb-4 flex items-center">
                            <img src="https://github.com/tandpfun/skill-icons/raw/main/icons/CS.svg" alt="icon"
                                className="w-fit h-12 mr-4" />
                            <p>C#</p>
                        </div>
                        <div className="bg-gray-200 rounded-lg p-4 mb-4 flex items-center">
                            <img src="https://github.com/tandpfun/skill-icons/raw/main/icons/CPP.svg" alt="icon"
                                className="w-fit h-12 mr-4" />
                            <p>C++</p>
                        </div>
                        <div className="bg-gray-200 rounded-lg p-4 mb-4 flex items-center">
                            <img src="https://github.com/tandpfun/skill-icons/raw/main/icons/Linux-Dark.svg" alt="icon"
                                className="w-fit h-12 mr-4" />
                            <p>Linux</p>
                        </div>
                        <div className="bg-gray-200 rounded-lg p-4 mb-4 flex items-center">
                            <img src="https://github.com/tandpfun/skill-icons/raw/main/icons/Git.svg" alt="icon"
                                className="w-fit h-12 mr-4" />
                            <p>Git</p>
                        </div>
                    </aside>
                    <aside className="w-1/3 max-sm:w-full max-sm:px-4">
                        <h2 className="text-center mb-2 underline">Frontend / Backend</h2>
                        <div className="bg-gray-200 rounded-lg p-4 mb-4 flex items-center">
                            <img src="https://github.com/tandpfun/skill-icons/raw/main/icons/HTML.svg" alt="icon"
                                className="w-fit h-12 mr-4" />
                            <p>HTML</p>
                        </div>
                        <div className="bg-gray-200 rounded-lg p-4 mb-4 flex items-center">
                            <img src="https://github.com/tandpfun/skill-icons/raw/main/icons/CSS.svg" alt="icon"
                                className="w-fit h-12 mr-4" />
                            <p>CSS</p>
                        </div>
                        <div className="bg-gray-200 rounded-lg p-4 mb-4 flex items-center">
                            <img src="https://github.com/tandpfun/skill-icons/raw/main/icons/React-Dark.svg" alt="icon"
                                className="w-fit h-12 mr-4" />
                            <p>React</p>
                        </div>
                        <div className="bg-gray-200 rounded-lg p-4 mb-4 flex items-center">
                            <img src="https://github.com/tandpfun/skill-icons/raw/main/icons/TailwindCSS-Dark.svg"
                                alt="icon" className="w-fit h-12 mr-4" />
                            <p>Tailwind</p>
                        </div>
                        <div className="bg-gray-200 rounded-lg p-4 mb-4 flex items-center">
                            <img src="https://github.com/tandpfun/skill-icons/raw/main/icons/NodeJS-Dark.svg" alt="icon"
                                className="w-fit h-12 mr-4" />
                            <p>Node.js</p>
                        </div>
                        <div className="bg-gray-200 rounded-lg p-4 mb-4 flex items-center">
                            <img src="https://github.com/tandpfun/skill-icons/raw/main/icons/MySQL-Dark.svg" alt="icon"
                                className="w-fit h-12 mr-4" />
                            <p>MySQL</p>
                        </div>
                    </aside>
                </section>
            </div>
        </div>
        </>
    );
}

export default Technologies;